import React from 'react';
import { Box, Typography, Button } from '@curves/ui-base';
import { parseDate } from '@Util/moment';
import HistoryRecordCard from './HistoryRecordCard';

const formatMonthLabel = (key) => parseDate(`${key}-01`, 'YYYY年M月');

// 月份小計：需求暫不顯示，保留供未來恢復（改為 true 即可開啟）
// 註：兌換紀錄的 points 為負值，恢復時以絕對值呈現「本月兌換 N 點」，不加 + 前綴
const SHOW_MONTHLY_TOTAL = false;

const RedeemHistoryList = ({ monthGroups = [], hasMore = false, onLoadMore }) => {
    if (monthGroups.length === 0) {
        return (
            <Box className="history-empty">
                <Typography className="history-empty-text">尚無點數紀錄</Typography>
            </Box>
        );
    }

    return (
        <Box className="history-list">
            {monthGroups.map(({ key, records, monthlyPoints }) => {
                const monthLabel = formatMonthLabel(key);
                return (
                    <Box key={key} className="history-month-section">
                        <Box className="history-month-header">
                            <Typography className="history-month-title">{monthLabel}</Typography>
                            {SHOW_MONTHLY_TOTAL && monthlyPoints !== 0 && (
                                <Typography className="history-month-total">本月兌換 {Math.abs(monthlyPoints)} 點</Typography>
                            )}
                        </Box>
                        <Box className="history-month-records">
                            {records.map((record) => (
                                <HistoryRecordCard key={record.recordID} record={record} />
                            ))}
                        </Box>
                    </Box>
                );
            })}
            {hasMore && (
                <Button variant="text" fullWidth onClick={onLoadMore} className="history-load-more">
                    載入更多
                </Button>
            )}
        </Box>
    );
};

export default RedeemHistoryList;
